import React from "react";
import moment from "moment";
import { TAnnex6V2Record } from "redux/app/annex6-v2/@types";
import { TAnnex6V2GroupJ1 } from "redux/app/annex6-v2/groups/group-j";
import Annex6V2TableRows from "../Annex6V2TableRows";

type OwnProps = {
	annex6V2Record: TAnnex6V2Record;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type Annex6V2GroupJ1PreviewProps = OwnProps;

function Annex6V2GroupJ1Preview(props: Annex6V2GroupJ1PreviewProps) {
	const record = props.annex6V2Record as TAnnex6V2GroupJ1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const { itemJ1P1, itemJ1P2, itemJ1P3, itemJ1P4 } = record;

	function renderMain() {
		const tableRows = [
			[operationDate, "J", "1", renderItemP1()],
			[null, null, "2", renderItemP2()],
		];

		if (itemJ1P2.isEGCSPerformanceVerifiable) {
			tableRows.push(
				[null, null, "3", renderItemP3()],
				[null, null, "4", renderItemP4()]
			);
		}

		if (record.remarks) {
			tableRows.push([null, null, "NOTE", record.remarks]);
		}

		return (
			<Annex6V2TableRows
				record={record}
				tableRows={tableRows}
				theme={props.theme}
			/>
		);
	}

	function renderItemP1() {
		return (
			<h4 className="font-medium uppercase">
				{itemJ1P1.place === "IN_PORT"
					? `EGCS Sensor failed at ${itemJ1P1.portName}`
					: `EGCS Sensor failed at ${itemJ1P1.latitude} | ${itemJ1P1.longitude}`}
			</h4>
		);
	}

	function renderItemP2() {
		return (
			<h4 className="font-medium uppercase">
				{itemJ1P2.isEGCSPerformanceVerifiable
					? "EGCS performance is verifiable"
					: "EGCS performance is not verifiable"}
			</h4>
		);
	}

	function renderItemP3() {
		return (
			<h4 className="font-medium uppercase">
				Fuel sulphur content used in affected ECGS is {itemJ1P3.sulphurContent}%
			</h4>
		);
	}

	function renderItemP4() {
		const {
			isCoastalStateInformedOfMalfunction,
			isFlagStateInformedOfMalfunction,
		} = itemJ1P4;
		let message = "";

		if (
			isCoastalStateInformedOfMalfunction &&
			isFlagStateInformedOfMalfunction
		) {
			message =
				"Both coastal state and flag state are informed about sensor malfunction.";
		} else if (isCoastalStateInformedOfMalfunction) {
			message = "Coastal state is informed about the sensor malfunction.";
		} else if (isFlagStateInformedOfMalfunction) {
			message = "Flag state is informed about the sensor malfunction.";
		} else {
			message =
				"Neither coastal state nor flag state informed about the sensor malfunction.";
		}

		return <h4 className="font-medium uppercase">{message}</h4>;
	}

	return renderMain();
}

export default Annex6V2GroupJ1Preview;
